import React from 'react';
import Title from '../Title';
import Cards from '../Cards';
import articles from '../../data/articles';
import { useTranslation } from 'react-i18next';

const NewsSection = () => {
  const { t, i18n } = useTranslation();
  const articlePageObj = i18n.getResource(i18n.resolvedLanguage, 'translation', 'news') ?? {};

  return (
    <div className='flex flex-col p-6 md:p-12 gap-6 md:gap-12'>
      <Title>{t('news.news_title')}</Title>
      <div className='text-center'>
        <p className='text-lg lg:text-xl font-light text-gray-500'>
          {t('news.news_subtitle')}
          <a
            href='https://www.linkedin.com/company/quantessence-financial-ltd/'
            target='_blank'
            rel='noopener noreferrer'
          >
            <span className='font-medium text-[#0277b5]'>Linkedin</span>
          </a>
        </p>
      </div>
      <Cards
        items={articles}
        linkPrefix='/news/article'
        imageKey='imgSrc'
        titleKey='title'
        linkKey='slug'
        emptyMessage='No articles available'
        showDetails={true}
        details={{
          date: (item) => {
            const articleKey = Object.keys(articlePageObj).find(
              (key) => articlePageObj[key].slug === item.slug
            );
            return articleKey ? t(`news.${articleKey}.article_date`) : '';
          },
        }}
        buttonLabel={t('news.news_button')}
        t={t}
        translate={true}
      />
    </div>
  );
};

export default NewsSection;
